import { motion ,AnimatePresence} from "framer-motion";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSiteContext } from "../../contexts/SiteProvider";
import { get } from "../../services/smartApiService";
import TraineesTable from "./TraineesTable";

const Sessions: React.FC = () => {
  const { type } = useParams<{ type: string }>();
  const { setTitle } = useSiteContext();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<any>(type || "today");

  const checkUpdateSessions=()=>{
    let URL ="exam/check";
    const subscription = get(URL).subscribe((_response) => {
      console.log("checkied");
    });
    return () => {
      subscription.unsubscribe();
    };

  }
  const tabContainerStyle = {
  position: "relative",
  width: "100%",
};

  useEffect(() => {
    checkUpdateSessions();
    setTitle("Sessions");
  }, []);

  useEffect(() => {
    setActiveTab(type || "today");
  }, [type]);

  const handleTabChange = (tabId: string) => {
    navigate(`/admin/sessions/${tabId}`);
  };
  const tabs = [
    { id: "today", label: "Today's Sessions" },
    { id: "completed", label: "Completed Sessions" },
    { id: "planned", label: "Upcoming Sessions" },
     { id: "passed", label: "Edit Sessions" },
  ];
  return (
    <div>
      {/* <h1 className="title"> Dashboard</h1> */}
      <div className="tabs-container">
        <div className="tabs is-boxed">
          <ul>
            {tabs.map((tab) => (
              <li
                key={tab.id}
                className={activeTab === tab.id ? "is-tab-active" : ""}
                onClick={() => handleTabChange(tab.id)}
              >
                {tab.label}
                {activeTab === tab.id && (
                  <motion.div
                    className="underline"
                    layoutId="underline"
                    initial={{ opacity: 0, y: 5 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 5 }}
                  />
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>

     
      <AnimatePresence mode="wait">
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
          
        >
          {activeTab === "today" && <TraineesTable mode="today" />}
          {activeTab === "completed" && <TraineesTable mode="completed" />}
          {activeTab === "planned" && <TraineesTable mode="planned" />}
          {activeTab === "passed" && <TraineesTable mode="passed" />}
        </motion.div>
      </AnimatePresence>
    

     
      {/* {activeTab == "previous" && <SessionCards />} */}
    </div>
  );
};

export default Sessions;
